<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="warehouseOrder">
      <!-- <el-form ref="addWarehouseAddressForm" :rules="rules" :model="addWarehouseAddressForm">
        <div class="wrap">
          <div class="main">
            <main class="main__content">
              <div class="step__sections">
                <div class="section section--shipping-address">
              </div>
              </div>
            </main>
          </div>
        </div>
      </el-form>-->

      <el-form ref="warehouseForm" :model="warehouseForm">
        <div class="wrap">
          <div class="main">
            <main class="main__content">
              <div class="step__sections" v-if="!submmited">
                <div class="section section--shipping-address">

                  <!-- service check list -->
                  <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                    <div class="title">
                      <span>{{ $t("serviceList") }}</span>
                    </div>
                    <div class="fieldset">
                      <el-checkbox-group v-model="customerOrder.serviceCheckList">
                        <el-row>
                          <el-col :span="6">
                            <el-checkbox label="Chaigui">{{ $t("serviceList_1") }}</el-checkbox>
                          </el-col>
                          <el-col :span="6">
                            <el-checkbox label="Chaigui45">{{ $t("serviceList_9") }}</el-checkbox>
                          </el-col>
                          <el-col :span="6">
                            <el-checkbox label="Paizhao">{{ $t("serviceList_2") }}</el-checkbox>
                          </el-col>
                          <el-col :span="6">
                            <el-checkbox label="Chanpinbiao">{{ $t("serviceList_3") }}</el-checkbox>
                          </el-col>

                        </el-row>
                        <el-row>
                          <el-col :span="6">
                            <el-checkbox label="Chucangfei">{{ $t("serviceList_4") }}</el-checkbox>
                          </el-col>
                          <el-col :span="6">
                            <el-checkbox label="Dabanfei">{{ $t("serviceList_5") }}</el-checkbox>
                          </el-col>
                          <el-col :span="6">
                            <el-checkbox label="Tiebiao">{{ $t("serviceList_6") }}</el-checkbox>
                          </el-col>
                          <el-col :span="6">
                            <el-checkbox label="Fenhuo">{{ $t("serviceList_7") }}</el-checkbox>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="24">
                            <el-checkbox label="CangChu">{{ $t("serviceList_8") }}</el-checkbox>
                          </el-col>
                        </el-row>
                      </el-checkbox-group>
                    </div>
                  </div>
                  <!-- end service check list -->

                  <!-- from address start -->
                  <div
                    class="section__content"
                    v-bind:style="{ marginBottom: 10 }"
                  >
                    <div class="title">
                      <span>{{ $t("shipFromAddress") }}</span>
                      <button class="btn" @click="newAddressAdd('Shipping')">
                        <i class="el-icon-plus"></i><span>{{ $t("addNewAddress") }}</span>
                      </button>
                    </div>
                    <!-- add address -->
                    <div class="fieldset">
                      <div class="field">
                        <!-- select from address book -->
                        <div
                          style="marginbottom: 1em"
                          class="address-container"
                          v-if="addresses.length > 0"
                        >
                          <div
                            style="margin: 0.2em"
                            v-for="address in addresses"
                            v-bind:key="address"
                          >
                            <div class="address-line">
                              <el-radio
                                v-model="customerOrder.shipFromAddressId"
                                :label="address.CustomerDetail_id"
                              >
                                <div class="next-line" style="flex-direction: row; display: flex;">
                                  <div class="radio-line">
                                    <span>
                                      Name: {{" " +address.FirstName + " " + address.LastName}}
                                    </span>
                                  </div>
                                  <div class="radio-line">
                                    <span>
                                      Address:{{" " +address.Street +", " +address.City +", " +address.State +" " +address.Zip}}
                                    </span>
                                  </div>
                                  <div class="radio-line">
                                    <span>Phone: {{" " +address.Telephone }} </span>
                                  </div>
                                </div>
                              </el-radio>
                              <div>
                                <el-button
                                  circle
                                  icon="el-icon-delete"
                                  type="primary"
                                  @click="deleteAddress(address.CustomerDetail_id)"
                                ></el-button>
                              </div>
                            </div>
                            <el-divider></el-divider>
                          </div>
                        </div>

                        <el-dialog
                          v-bind:title="$t('addNewAddress')"
                          :visible.sync="addressModalVisible"
                          @close="handleClose"
                          class="modal"
                        >
                          <el-form
                            ref="addWarehouseAddressForm"
                            :model="addWarehouseAddressForm"
                          >
                            <div class="fieldset">
                              <div class="field">
                                <div v-if="errorAdding" class="time_tip">
                                  <span>{{ $t("correctErrors") }}</span>
                                </div>
                                <div class="two">
                                  <div class="width">
                                    <el-form-item
                                      prop="FirstName"
                                      v-bind:label="$t('firstName')"
                                    >
                                      <el-input
                                        v-bind:placeholder="$t('firstName')"
                                        v-model="addWarehouseAddressForm.FirstName"
                                      ></el-input>
                                    </el-form-item>
                                  </div>
                                  <div class="width">
                                    <el-form-item
                                      prop="LastName"
                                      v-bind:label="$t('LastName')"
                                    >
                                      <el-input
                                        v-bind:placeholder="$t('lastName')"
                                        v-model="addWarehouseAddressForm.LastName"
                                      ></el-input>
                                    </el-form-item>
                                  </div>
                                </div>
                                <el-row :gutter="20">
                                  <el-col :span="12">
                                    <div>
                                      <el-form-item
                                        prop="CompanyName"
                                        v-bind:label="$t('companyName')"
                                      >
                                        <el-input
                                          v-bind:placeholder="$t('companyName')"
                                          v-model="addWarehouseAddressForm.CompanyName"
                                        ></el-input>
                                      </el-form-item>
                                      </div>
                                    </el-col>
                                  <el-col :span="12">
                                    <div class="width">
                                      <el-form-item
                                        prop="Telephone"
                                        v-bind:label="$t('mobilePhone') + $t('optional')"
                                      >
                                        <el-input
                                          v-bind:placeholder="$t('mobilePhone')"
                                          v-model="addWarehouseAddressForm.Telephone"
                                        ></el-input>
                                      </el-form-item>
                                    </div>
                                  </el-col>
                                </el-row>
                                <div v-if="showEmailArray">
                                  <div class="width">
                                    <el-form-item
                                      prop="email"
                                      v-bind:label="$t('emailArray')"
                                    >
                                      <el-input
                                        v-bind:placeholder="$t('email')"
                                        v-model="addWarehouseAddressForm.Email"
                                      ></el-input>
                                    </el-form-item>
                                  </div>
                                </div>
                                <div class="input_box" v-if="addWarehouseAddressForm.AddressType==='BillingAddress'">
                                  <p>Where is the address located? &nbsp;&nbsp;</p>
                                  <el-radio-group v-model="addWarehouseAddressForm.IsUSA">
                                    <el-radio :label="true">US</el-radio>
                                    <el-radio :label="false">Non-US</el-radio>
                                  </el-radio-group>
                                </div>
                                <div v-if="!addWarehouseAddressForm.IsUSA">
                                  <div class="width">
                                    <el-form-item
                                      prop="nonUSAddress"
                                      v-bind:label="$t('addressIncludingApt')"
                                    >
                                      <el-input
                                        v-bind:placeholder="$t('nonUSAddress')"
                                        v-model="addWarehouseAddressForm.nonUSAddress"
                                      ></el-input>
                                    </el-form-item>
                                  </div>
                                </div>
                                <div v-if="addWarehouseAddressForm.IsUSA" class="address-search">
                                  <el-select
                                    prop="typedAddress"
                                    v-model="addWarehouseAddressForm.typedAddress"
                                    filterable
                                    remote
                                    placeholder="Please search an address"
                                    :remote-method="palceAutocompleteSearch"
                                    @change="addressDetail"
                                    :loading="autoCompleteLoading"
                                  >
                                    <el-option
                                      v-for="item in palceAutoSearch"
                                      :key="item.place_id"
                                      :label="item.address"
                                      :value="item.place_id"
                                    >
                                    </el-option>
                                  </el-select>
                                </div>
                                <div class="two" v-if="addWarehouseAddressForm.IsUSA">
                                  <div class="width">
                                    <div>
                                      <el-form-item
                                        prop="Street"
                                        v-bind:label="$t('street')"
                                      >
                                        <el-input
                                          v-bind:placeholder="$t('street')"
                                          v-model="addWarehouseAddressForm.Street"
                                        ></el-input>
                                      </el-form-item>
                                    </div>
                                  </div>
                                  <div class="width">
                                    <div>
                                      <el-form-item
                                        prop="AptNumber"
                                        v-bind:label="$t('aptNumber')"
                                      >
                                        <el-input
                                          v-bind:placeholder="$t('aptNumber')"
                                          v-model="addWarehouseAddressForm.AptNumber"
                                        ></el-input>
                                      </el-form-item>
                                    </div>
                                  </div>
                                </div>
                                <div class="three" v-if="addWarehouseAddressForm.IsUSA">
                                  <div class="width_30">
                                    <div>
                                      <el-form-item
                                        prop="City"
                                        v-bind:label="$t('city')"
                                      >
                                        <el-input
                                          v-bind:placeholder="$t('city')"
                                          v-model="addWarehouseAddressForm.City"
                                        ></el-input>
                                      </el-form-item>
                                    </div>
                                  </div>
                                  <div class="width_30">
                                    <div>
                                      <el-form-item
                                        prop="State"
                                        v-bind:label="$t('state')"
                                      >
                                        <el-select
                                          v-model="addWarehouseAddressForm.State"
                                          v-bind:placeholder="$t('pleaseSelect')"
                                          value=""
                                        >
                                          <el-option
                                            v-for="item in stateOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                          >
                                          </el-option>
                                        </el-select>
                                      </el-form-item>
                                    </div>
                                  </div>
                                  <div class="width_30">
                                    <div>
                                      <el-form-item
                                        prop="Zip"
                                        v-bind:label="$t('zipCode')"
                                      >
                                        <el-input
                                          v-bind:placeholder="$t('zipCode')"
                                          v-model="addWarehouseAddressForm.Zip"
                                        ></el-input>
                                      </el-form-item>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="end">
                                <button
                                  class="btn"
                                  @click="submitNewAddress(addWarehouseAddressForm, $event)"
                                >
                                  {{ $t("submit") }}
                                </button>
                              </div>
                            </div>
                          </el-form>
                        </el-dialog>
                      </div>
                    </div>
                  </div>
                  <!-- from address end -->

                  <!-- to address start -->
                  <div
                    class="section__content"
                    v-bind:style="{ marginBottom: 10 }"
                  >
                    <div class="title">
                      <span>{{ $t("shipToAddress") }}</span>
                    </div>
                    <div class="fieldset">
                      <div>
                        <span>{{ $t("fulfillmentByAmz") }}</span>
                        <el-form
                          :label-position="top"
                          label-width="0px"
                          :model="warehouseForm"
                        >
                          <el-form-item>
                            <el-select
                              filterable
                              value-key="id"
                              v-model="customerOrder.shipToAddress"
                              placeholder="select ship to address..."
                              @change="fbaAddressChanged"
                            >
                              <el-option
                                v-for="item in this.$store.state.warehouseOrder.warehouseAddress"
                                :key="item.id"
                                :label="`${item.FBACode} - ${item.Address}`"
                                :value="item"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-form>
                        <div class="title1">
                          <el-checkbox
                            @change="isNoneFBAStatus"
                            v-model="isNoneFBA"
                          >{{ $t("noneFBA") }}
                          </el-checkbox>
                          <button
                            class="btn"
                            @click="newAddressAdd('NoneFBAAddress')"
                          >
                            <i class="el-icon-plus"></i>
                            <span>{{ $t("addNewAddress") }}</span>
                          </button>
                        </div>
                        <!-- none fba address book start -->
                        <div style="padding-top: 20px;">
                          <div
                            style="marginbottom: 1em"
                            class="address-container"
                            v-if="noneFBAAddressArray.length > 0"
                          >
                            <div
                              style="margin: 0.2em"
                              v-for="address in noneFBAAddressArray"
                              v-bind:key="address"
                            >
                              <div class="address-line">
                                <el-radio
                                  :disabled="noneFABRadio"
                                  v-model="customerOrder.noneFBAAddressId"
                                  :label="address.CustomerDetail_id"
                                >
                                  <div
                                    class="next-line"
                                    style="flex-direction: row; display: flex"
                                  >
                                    <div class="radio-line">
                                      <span>
                                        Name:{{address.FirstName + " " + address.LastName}}
                                      </span>
                                    </div>
                                    <div class="radio-line">
                                      <span>
                                        Address:
                                        {{address.Street+", "+address.City+", " +address.State +" " +address.Zip}}
                                      </span>
                                    </div>
                                    <div class="radio-line">
                                      <span>Phone: {{ address.Telephone }} </span>
                                    </div>
                                  </div>
                                </el-radio>
                                <div class="radio-line">
                                  <el-button
                                    circle
                                    icon="el-icon-delete"
                                    type="primary"
                                    @click="deleteAddress(address.CustomerDetail_id)"
                                  ></el-button>
                                </div>
                              </div>
                              <el-divider></el-divider>
                            </div>
                          </div>
                        </div>
                        <!-- none fba address book end -->
                      </div>
                    </div>
                  </div>
                  <!-- to address end -->

                  <!-- bill address start -->
                  <div
                    class="section__content"
                    v-bind:style="{ marginBottom: 10 }"
                  >
                    <div class="title">
                      <span>{{ $t("thirdPartyBillTo") }}</span>
                      <button class="btn" @click="newAddressAdd('BillingAddress')">
                        <i class="el-icon-plus"></i><span>{{ $t("addNewAddress") }}</span>
                      </button>
                    </div>
                    <div class="fieldset">
                      <div class="field">
                        <!-- select bill address book -->
                        <div
                          style="marginbottom: 1em"
                          class="address-container"
                          v-if="billingAddressArray.length > 0"
                        >
                          <div
                            style="margin: 0.2em"
                            v-for="address in billingAddressArray"
                            v-bind:key="address"
                          >
                            <div class="address-line">
                              <el-radio
                                v-model="customerOrder.billingAddressId"
                                :label="address.CustomerDetail_id"
                              >
                                <div
                                  class="next-line"
                                  style="flex-direction: row; display: flex"
                                >
                                  <div class="radio-line">
                                    <span>
                                      Name:{{address.FirstName + " " + address.LastName}}
                                    </span>
                                  </div>
                                  <div class="radio-line">
                                    <span>
                                      Address:{{address.Street +", " +address.City +", " +address.State +" " +address.Zip}}
                                    </span>
                                  </div>
                                  <div class="radio-line">
                                    <span>Phone: {{ address.Telephone }} </span>
                                  </div>
                                </div>
                              </el-radio>
                              <div class="radio-line">
                                <el-button
                                  circle
                                  icon="el-icon-delete"
                                  type="primary"
                                  @click="deleteAddress(address.CustomerDetail_id)"
                                ></el-button>
                              </div>
                            </div>
                            <el-divider></el-divider>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- bill address end -->

                  <!-- customer order info start -->
                  <div
                    class="section__content"
                    v-bind:style="{ marginBottom: 10 }"
                  >
                    <div class="title">
                      <span>{{ $t("customerOrderInfo") }}</span>
                    </div>
                    <div class="fieldset">
                      <div>
                        <el-row :gutter="20">
                          <el-col :span="12">
                            <div>
                              <el-form-item v-bind:label="$t('bolNumber')" prop="bolNumber">
                                <el-input
                                  v-model="customerOrder.BOLNo"
                                  v-bind:placeholder="$t('bolNumber')"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </el-col>
                          <el-col :span="12">
                            <div>
                              <el-form-item v-bind:label="$t('containerNum')" prop="bolNumber">
                                <el-input
                                  v-model="customerOrder.containerNo"
                                  v-bind:placeholder="$t('containerNum')"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                      <div class="customerInfoTable">
                        <el-table
                          :data="customerOrder.orderLine"
                          border
                          style="width: 100%"
                          show-summary
                        >
                          <el-table-column :label="$t('referenceNum')" width="180">
                            <template slot-scope="scope">
                              <el-input v-model="scope.row.referenceNo"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('proNumber')" width="180">
                            <template slot-scope="scope">
                              <el-input v-model="scope.row.PRONo"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column
                            :label="$t('pallet')"
                            width="150"
                            prop="palletCount"
                          >
                            <template slot-scope="scope">
                              <el-input-number
                                style="width: 110px"
                                v-model="scope.row.palletCount"
                                controls-position="right"
                                :min="0"
                                :max="9999"
                              ></el-input-number>
                            </template>
                          </el-table-column>
                          <el-table-column
                            :label="$t('numPkgs')"
                            width="150"
                            prop="cartonCount"
                          >
                            <template slot-scope="scope">
                              <el-input-number
                                style="width: 110px"
                                v-model="scope.row.cartonCount"
                                controls-position="right"
                                :min="0"
                                :max="9999"
                              ></el-input-number>
                            </template>
                          </el-table-column>
                          <el-table-column
                            :label="$t('weight')"
                            width="150"
                            prop="weight"
                          >
                            <template slot-scope="scope">
                              <el-input-number
                                style="width: 110px"
                                v-model="scope.row.weight"
                                controls-position="right"
                                :min="0"
                                :max="9999"
                              ></el-input-number>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('commodityDesc')" width="350">
                            <template slot-scope="scope">
                              <el-input v-model="scope.row.commodityDesc"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column label="Action" width="70">
                            <template slot-scope="scope">
                              <el-button
                                icon="el-icon-delete"
                                type="primary"
                                circle
                                @click.native.prevent="deleteRow(scope.$index,customerOrder.orderLine)"
                              >
                              </el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>

                      <el-row>
                        <el-col :span="24">
                          <div class="grid-content bg-purple-dark">
                            <span>{{ $t("estimateAmount") }}: ${{ totalAmount }}</span>
                          </div>
                        </el-col>
                      </el-row>
                      <el-button
                        type="primary"
                        icon="el-icon-plus"
                        circle
                        @click="addNewLine"
                      ></el-button>
                    </div>
                  </div>
                  <!-- customer order info end -->
                </div>
                <!-- <div v-bind:style="{ display: 'flex', 'justify-content': 'center', 'align-items': 'center' }">
                  <div style="display: table; margin: 0 auto;">
                    <input type="checkbox" id="read" value="read" v-model="read">
                    <label for="read">条款声明</label>
                  </div>
                </div> -->
                <!-- <button :disabled="!read" class="place btn" @click="onSubmit(warehouseForm, $event)">{{ $t('submit') }}</button> -->
                <button
                  class="place btn"
                  @click="onSubmit(customerOrder, $event)"
                >
                  {{ $t("submit") }}
                </button>
              </div>
            </main>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {mapState, mapMutations, mapActions} from "vuex";
  import {Alert} from "element-ui";
  import axios from "axios";
  import breadcrumb from "../components/breadcrumb";
  import logo from "../assets/img/logo.png";
  import addresses from "../store/modules/addresses";
  import {validateUSZipCode, validatePhoneNumber} from "../../config/validation";
  import {
    palceSearch,
    fetchAddressDetail,
    fetchNoneFBAAddress,
    deleteCustomerDetail,
  } from "../store/modules/addresses";

  export default {
    name: "warehouseOrder",
    components: {
      breadcrumb,
    },
    data() {
      return {
        errors: [],
        address: "",
        addressChoice: "",
        autoCompleteLoading: false,
        isNoneFBA: false,
        noneFABRadio: true,
        palceAutoSearch: [],
        noneFBAAddressArray: [],
        billingAddressArray: [],
        totalAmount: 0,
        stateOptions: this.$store.state.addresses.states,
        warehouseAddressChoice: "",
        customerOrder: {
          serviceCheckList: [],
          shipFromAddressId: "",
          shipToAddress: null,
          noneFBAAddressId: "",
          billingAddressId: "",
          BOLNo: "",
          containerNo: "",
          orderLine: [
            {
              referenceNo: "",
              PRONo: "",
              palletCount: "",
              cartonCount: "",
              weight: "",
              commodityDesc: "",
            },
          ],
        },

        // Order form data
        warehouseForm: {
          ProductId: "",
          OrderLines: [
            {
              // ship from
              ShipFromId: "", // Customer Detail id from the address book

              // ship to
              ShipTo: "",

              // SCAC and ProNo
              BillOfLadingNo: "",
              SCAC: "",
              ProNo: "",

              // order information
              ReferenceInfos: [
                {
                  RefNo: "",
                  PackageSize: "",
                  Weight: "",
                  Quantity: "", // pallet qty
                  AdditionalInfo: "", // additional shipper info
                },
              ],
            },
          ],
        },

        // add address data
        addressModalVisible: false,
        showEmailArray: false,
        errorAdding: false,
        read: null,

        // for AdditionalInfo
        addWarehouseAddressForm: {
          FirstName: "",
          LastName: "",
          Street: "",
          Telephone: "",
          Email: "",
          IsUSA: true,
          nonUSAddress: "",
          City: "",
          Zip: "",
          Country: "United States",
          State: "",
          CompanyName: "",
          AddressType: "",
          AptNumber: "",
          typedAddress: "",
        },

        // dropdown boolean
        isAddAddress: true,
        errorSubmitting: false,
        success: false,
        submmited: false,
        path2: this.$t("placeYourOrder"),
      };
    },
    watch: {
      "customerOrder.orderLine": {
        handler(newVal, oldVal) {
          this.calculateTotalAmount();
        },
        deep: true,
      },
    },
    computed: mapState({
      addresses: (state) => state.addresses.customerDetails,
    }),
    methods: {
      ...mapActions("warehouseOrder", [
        "fetchWarehouseAddresses",
        "fetchWarehouseUnitPrice",
        "submit",
      ]),
      // ...mapActions(
      //   'addresses',
      //   ['deleteAddress, deleteCustomerDetail'],
      // ),
      ...mapMutations("warehouseOrder", ["getOrderDetail"]),
      newAddressAdd(addressType) {
        event.preventDefault();
        if (addressType === "BillingAddress") {
          this.showEmailArray = true;
        } else { this.showEmailArray = false; }
        this.addressModalVisible = true;
        // this.$refs['addWarehouseAddressForm'].resetFields();
        this.addWarehouseAddressForm.typedAddress = ""
        this.palceAutoSearch = []
        this.addWarehouseAddressForm.AddressType = addressType;
      },
      calculateTotalAmount() {
        var totalPallet = 0;
        this.customerOrder.orderLine.forEach((item, index) => {
          totalPallet += item.palletCount;
        });
        if (this.customerOrder.shipToAddress === null) {
          this.totalAmount = 0;
        }
        var unitPrice = this.customerOrder.shipToAddress.UnitPrice;
        if (totalPallet >= 6) {
          unitPrice = this.customerOrder.shipToAddress.DiscountPrice;
        }
        this.totalAmount = totalPallet * unitPrice;
      },
      isNoneFBAStatus(status) {
        if (status) {
          this.customerOrder.shipToAddress = null;
          // fetch none fab address
          this.noneFBAAddress("NoneFBAAddress");
          this.noneFABRadio = false;
        }
      },
      noneFBAAddress(type) {
        fetchNoneFBAAddress({
          Type: type,
        }).then((data) => {
          if (type === "NoneFBAAddress") {
            this.noneFBAAddressArray = data.Customer_Detail;
            this.calculateTotalAmount();
          } else {
            this.billingAddressArray = data.Customer_Detail;
          }
        });
      },
      palceAutocompleteSearch(address) {
        if (address === "") {
          return;
        }
        this.autoCompleteLoading = true;
        palceSearch({
          address: address,
        }).then((response) => {
          this.palceAutoSearch = response;
          this.autoCompleteLoading = false;
        });
      },
      // deleteAddress(id) {
      //   this.$store.dispatch('addresses/deleteAddress', id);
      // },
      deleteAddress(customerDetailId) {
        deleteCustomerDetail(customerDetailId).then((response) => {
          this.noneFBAAddress("BillingAddress");
          this.noneFBAAddress("NoneFBAAddress");
          this.$store.dispatch("addresses/fetchAddresses");

          this.$notify({
            title: "Success",
            message: "successfully deleted",
            type: "success",
          });
        });
      },
      addressDetail(address) {
        if (address === "") {
          return;
        }
        fetchAddressDetail({
          addressId: address,
        }).then((data) => {
          this.addWarehouseAddressForm.Street =
            data.street_number + " " + data.route;
          this.addWarehouseAddressForm.City = data.locality;
          this.addWarehouseAddressForm.State = data.administrative_area_level_1;
          this.addWarehouseAddressForm.Zip = data.postal_code;
        });
      },
      fbaAddressChanged(address) {
        this.isNoneFBA = false;
        this.noneFABRadio = true;
        this.customerOrder.noneFBAAddressId = null;
        this.calculateTotalAmount();
      },
      addNewLine() {
        this.customerOrder.orderLine.push({
          referenceNo: "",
          PRONo: "",
          palletCount: "",
          cartonCount: "",
          weight: "",
          commodityDesc: "",
        });
      },
      deleteRow(index, rows) {
        rows.splice(index, 1);
      },
      handleClose(event) {
        event.preventDefault();
        this.$refs['addWarehouseAddressForm'].resetForm();
        this.addressModalVisible = false;
      },
      submitNewAddress(address, event) {
        this.errors = []
        let email = address.email;
        // let emailArray = email.replace(/ /g,'').split(",");

        event.preventDefault();
        if (address.IsUSA === true) {
          this.checkAddressForm(address);
        }
        if (this.addWarehouseAddressForm.AddressType === 'BillingAddress') {
          if (this.addWarehouseAddressForm.Email === ''){
            this.errors.push(this.$t("emailRequired"));
          }
          if (address.IsUSA === false && this.addWarehouseAddressForm.nonUSAddress === '') {
            this.errors.push(this.$t("addressRequired"));
          }
        }
        if (!this.errors.length) {
          this.$store.dispatch("addresses/postAddress", address).then(() => {
            this.noneFBAAddress("BillingAddress");
            this.noneFBAAddress("NoneFBAAddress");
            this.$store.dispatch("addresses/fetchAddresses");
            this.resetForm();
            this.addressModalVisible = false;
          });
        } else {
          alert(this.errors);
        }
      },
      resetForm() {
        this.addWarehouseAddressForm = {
          FirstName: "",
          LastName: "",
          Street: "",
          Telephone: "",
          Email: "",
          IsUSA: true,
          nonUSAddress: "",
          City: "",
          Zip: "",
          Country: "United States",
          State: "",
          CompanyName: "",
        };
      },
      checkAddressForm: async function (form) {
        this.errors = [];
        if (!form.Street) {
          this.errors.push(this.$t("addressRequired"));
        }
        if (!form.City) {
          this.errors.push(this.$t("cityRequired"));
        }
        if (!form.Country) {
          this.errors.push(this.$t("countryRequired"));
        }
        if (!form.State) {
          this.errors.push(this.$t("stateRequired"));
        }
        if (!form.CompanyName) {
          this.errors.push(this.$t("companyNameRequired"));
        }
        if (validateUSZipCode(form.Zip)) this.errors.push(this.$t("zipCodeWrong"));
        // if (validatePhoneNumber(form.Telephone))
        //   this.errors.push(this.$t("phoneNumberWrong"));
      },
      onSubmit(customerOrder, event) {
        event.preventDefault();
        this.errors = [];
        this.errorSubmitting = false;
        this.checkForm();
        if (!this.errors.length) {
          this.submit(customerOrder)
            .then((res) => {
              this.getOrderDetail(res.data); // save in store
              if (res.data.BypassPayment === false) {
                this.$refs["warehouseForm"].clearValidate();
                this.errors = "";
                // this.goToPayment(res.data.SONum); // go to payment page
                this.openAlert(false);
              } else {
                this.$refs["warehouseForm"].clearValidate();
                this.errors = "";
                this.openAlert(true); // show success message
              }
            })
            .catch((err) => {
              alert(err);
            });
        } else {
          this.errorSubmitting = true;
          alert(this.errors);
        }
      },
      checkForm: function () {
        if (this.customerOrder.shipFromAddressId === "") {
          this.errors.push("Please select a shipping from address");
          return;
        }
        if (
          this.customerOrder.shipToAddress === null &&
          this.customerOrder.noneFBAAddressId === ""
        ) {
          this.errors.push("Please select a shipping to address");
          return;
        }
        if (this.customerOrder.billingAddressId === "") {
          this.errors.push("Please select a billing address");
          return;
        }
        },
      openAlert(BypassPayment) {
        // this.submmited = true;
        this.addressModalVisible = false;
        let message = "You have submitted an order.";
        if (BypassPayment === false) {
          message =
            "You have submitted an order, please pay at order detail once it got picked up";
        }
        this.$alert(message, "Success", {
          confirmButtonText: "OK",
          type: "success",
          center: true,
        }).then(() => {
          window.location.reload();
        });
      },
      goToPayment(SONum) {
        this.$router.push(`/payment/${SONum}`);
      },
      deactivated() {
        this.submmited = false;
      },
    },
    mounted: function () {
      this.$store.dispatch("addresses/fetchAddresses");
      this.$store.dispatch("warehouseOrder/fetchWarehouseAddresses");
      this.$store.dispatch("warehouseOrder/fetchWarehouseUnitPrice");
      this.noneFBAAddress("BillingAddress");
    },
  };
</script>

<style lang="less">
  @import "../assets/css/warehouseOrder.less";
</style>



// WEBPACK FOOTER //
// src/view/warehouseOrder.vue